import React from 'react';
import { useState, useEffect } from 'react';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import { Helmet } from "react-helmet";

function Home() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const eventDate = new Date('2025-06-01T00:00:00').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventDate - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Servizio Ritratto Premium',
      shortDescription: 'Sessione fotografica professionale con ritratti artistici di alta qualita in studio',
      description: 'Il nostro servizio di ritratto premium offre una sessione fotografica professionale completa in studio con illuminazione cinematografica. Include consulenza stilistica, 3 ore di shooting, 50 foto ritoccate professionalmente e album digitale premium. Catturiamo la tua essenza attraverso ritratti artistici che raccontano la tua storia unica.',
      price: 499.00,
      image: '/images/1.jpg',
      rating: 5
    },
    {
      id: 2,
      name: 'Pacchetto Famiglia Deluxe',
      shortDescription: 'Servizio fotografico completo per famiglie con sessione outdoor e indoor',
      description: 'Pacchetto fotografico familiare deluxe che comprende sessione outdoor in location esclusiva e sessione indoor in studio. Include 4 ore di shooting, consulenza pre-servizio, 80 foto ritoccate, stampe premium formato 30x40cm e album fotografico rilegato in pelle. Immortaliamo i momenti piu preziosi della vostra famiglia.',
      price: 799.00,
      image: '/images/2.jpg',
      rating: 5
    },
    {
      id: 3,
      name: 'Wedding Photography Elite',
      shortDescription: 'Copertura fotografica completa per matrimoni con servizio premium',
      description: 'Servizio fotografico elite per matrimoni che include copertura completa della giornata, dalla preparazione fino al ricevimento. Due fotografi professionisti, 10 ore di copertura, 200+ foto ritoccate artisticamente, video highlights cinematografico, album matrimoniale premium rilegato a mano e stampe artistiche su tela.',
      price: 2499.00,
      image: '/images/3.jpg',
      rating: 5
    },
    {
      id: 4,
      name: 'Corporate Branding Package',
      shortDescription: 'Servizio fotografico professionale per aziende e professionisti',
      description: 'Pacchetto completo per branding aziendale che include ritratti professionali del team, foto degli spazi aziendali, shooting di prodotti e materiale promozionale. Sessione di 5 ore, 100 foto ritoccate professionalmente, ottimizzazione per web e social media, e diritti commerciali completi.',
      price: 1299.00,
      image: '/images/4.jpg',
      rating: 5
    },
    {
      id: 5,
      name: 'Fashion Editorial Premium',
      shortDescription: 'Sessione fotografica editoriale fashion con styling professionale',
      description: 'Servizio editoriale fashion premium che include sessione fotografica in studio professionale con styling completo, makeup artist, hair stylist e consulenza fashion. 6 ore di shooting, 60 foto ritoccate ad alto livello, post-produzione artistica avanzata e portfolio digitale ottimizzato per pubblicazioni.',
      price: 1799.00,
      image: '/images/5.jpg',
      rating: 5
    }
  ];

  const testimonials = [
    {
      text: 'Esperienza fotografica assolutamente straordinaria! Il team di Haridem ha catturato perfettamente l essenza della nostra famiglia. Le foto sono opere d arte che custodiremo per sempre.',
      author: 'Sofia Mariani'
    },
    {
      text: 'Professionalita impeccabile e risultati mozzafiato. Il servizio wedding e stato semplicemente perfetto, ogni momento del nostro giorno speciale e stato immortalato magnificamente.',
      author: 'Marco e Laura Ferretti'
    },
    {
      text: 'Le fotografie corporate hanno elevato significativamente l immagine della nostra azienda. Qualita premium e attenzione ai dettagli che fanno la differenza.',
      author: 'Alessandro Bianchi, CEO'
    },
    {
      text: 'Servizio fashion editoriale di altissimo livello. Il team e incredibilmente talentuoso e le foto finali hanno superato ogni nostra aspettativa. Semplicemente perfetto!',
      author: 'Valentina Romano'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div>
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Haridem Studio</h1>
          <p className="hero-subtitle">
            Fotografia d arte contemporanea con estetica cinematografica premium. 
            Catturiamo momenti indimenticabili attraverso studio fotografico ritratti emozionanti e composizioni visive straordinarie.
          </p>
          
          <div className="countdown-section">
            <h3 className="countdown-title">Prossimo Evento Esclusivo</h3>
            <div className="countdown-timer">
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.days}</span>
                <span className="countdown-label">Giorni</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.hours}</span>
                <span className="countdown-label">Ore</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.minutes}</span>
                <span className="countdown-label">Minuti</span>
              </div>
              <div className="countdown-item">
                <span className="countdown-number">{timeLeft.seconds}</span>
                <span className="countdown-label">Secondi</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="advantages-section">
        <div className="advantages-header">
          <h2 className="advantages-title">Perche Scegliere Haridem</h2>
          <p className="advantages-description">
            Offriamo servizi fotografici premium che trasformano i tuoi momenti piu preziosi 
            in opere d arte senza tempo. Qualita studio fotografo eccezionale garantita.
          </p>
        </div>

        <div className="advantages-grid">
          <div className="advantage-card">
            <div className="advantage-icon"><FaStar /></div>
            <h3 className="advantage-title">Qualita Premium</h3>
            <p className="advantage-text">
              Utilizziamo esclusivamente attrezzature fotografiche professionali di ultima 
              generazione per garantire risultati di qualita cinematografica eccezionale.
            </p>
          </div>
          <div className="advantage-card">
            <div className="advantage-icon"><FaHeart /></div>
            <h3 className="advantage-title">Passione Artistica</h3>
            <p className="advantage-text">
              Ogni scatto e curato con dedizione artistica e attenzione maniacale ai dettagli, 
              creando fotografie che raccontano storie emozionanti e autentiche.
            </p>
          </div>
          <div className="advantage-card">
            <div className="advantage-icon"><FaShoppingCart /></div>
            <h3 className="advantage-title">Servizio Completo</h3>
            <p className="advantage-text">
              Pacchetti all inclusive che comprendono consulenza, shooting, post-produzione 
              professionale e consegna ritratto in bianco e nero in formati premium digitali e stampati.
            </p>
          </div>
          <div className="advantage-card">
            <div className="advantage-icon"><FaHome /></div>
            <h3 className="advantage-title">Studio Professionale</h3>
            <p className="advantage-text">
              Studio fotografico attrezzato con tecnologia all avanguardia, set versatili 
              e illuminazione ritratti bianco e nero cinematografica per risultati straordinari.
            </p>
          </div>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <span className="stat-number">2500+</span>
            <span className="stat-label">Clienti Soddisfatti</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">15</span>
            <span className="stat-label">Anni di Esperienza</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">5000+</span>
            <span className="stat-label">Progetti Completati</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Garanzia Qualita</span>
          </div>
        </div>

        <div className="cta-container">
          <p className="cta-text">
            Pronto a creare ricordi indimenticabili con fotografie straordinarie?
          </p>
          <a href="#catalog" className="cta-button">Esplora i Nostri Servizi</a>
        </div>
      </section>

      <section className="detailed-info-section">
        <h2 className="detailed-info-title">L Eccellenza Fotografica di Haridem</h2>
        <div className="info-content">
          <div className="info-block">
            <h3>Arte e Tecnica Fotografica</h3>
            <p>
              Haridem Photography Studio photo studio rappresenta l eccellenza nella fotografia contemporanea italiana, 
              combinando maestria tecnica e sensibilita artistica per creare immagini che trascendono 
              il semplice scatto fotografico. I nostri servizi fotografici premium sono progettati per 
              catturare l essenza autentica di ogni momento, trasformandolo in un opera d arte senza tempo.
            </p>
            <p>
              Utilizziamo tecnologie fotografiche all avanguardia, illuminazione cinematografica professionale 
              e tecniche di post-produzione avanzate per garantire risultati di qualita eccezionale che 
              superano ogni aspettativa.
            </p>
          </div>

          <div className="info-block">
            <h3>Qualita e Professionalita</h3>
            <p>
              Ogni nostro servizio fotografico e caratterizzato da standard qualitativi rigorosi. Dalla 
              consulenza iniziale alla consegna finale, ogni fase e curata con attenzione maniacale ai 
              dettagli. Il nostro team di fotografi professionisti vanta anni di esperienza internazionale 
              in fotografia editoriale, wedding, corporate e ritrattistica artistica.
            </p>
            <p>
              Garantiamo risultati professionali attraverso l uso di attrezzature fotografiche premium, 
              obiettivi di altissima qualita e workflow di post-produzione certificati che assicurano 
              colori fedeli, nitidezza impeccabile e atmosfera cinematografica unica.
            </p>
          </div>

          <div className="info-block">
            <h3>Certificazioni e Garanzie</h3>
            <p>
              Haridem Studio e certificato come centro di eccellenza fotografica professionale. Tutti i 
              nostri servizi sono coperti da garanzia totale di soddisfazione cliente. Le fotografie 
              vengono consegnate in formati premium ottimizzati sia per stampa professionale che per 
              utilizzo digitale, con profili colore certificati e risoluzione massima.
            </p>
            <p>
              Offriamo inoltre diritti d uso completi sulle immagini, backup sicuri a lungo termine e 
              supporto post-consegna per qualsiasi esigenza di ristampa o utilizzo commerciale.
            </p>
          </div>

          <div className="info-block">
            <h3>Storia e Visione</h3>
            <p>
              Fondato nel 2010, Haridem Photography Studio e nato dalla passione per la fotografia d arte 
              e il desiderio di elevare gli standard della fotografia professionale italiana. In oltre 
              15 anni di attivita, abbiamo realizzato migliaia di progetti fotografici per clienti privati, 
              aziende e pubblicazioni editoriali di prestigio.
            </p>
            <p>
              La nostra visione e quella di continuare a innovare nel campo della fotografia contemporanea, 
              mantenendo sempre al centro la qualita shooting fotografico artistica, l autenticita emotiva e la soddisfazione 
              totale dei nostri clienti. Ogni progetto e un opportunita per creare qualcosa di straordinario 
              e indimenticabile.
            </p>
          </div>
        </div>
      </section>

      <section className="catalog-section" id="catalog">
        <h2 className="section-title">I Nostri Servizi Premium</h2>
        <div className="products-grid">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>

      <section className="testimonials-section">
        <h2 className="testimonials-title">Cosa Dicono i Nostri Clienti</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <p className="testimonial-text">{testimonial.text}</p>
              <p className="testimonial-author">— {testimonial.author}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  
    </>);
}

export default Home;